import React from "react";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { trackEvent, EC_SHOP, E_ORDER_COMPLETED } from "../../helpers/tracking";
import { vendorPath } from "../../helpers";
import { confetti } from "../../assets/confetti";

export default function CheckoutSuccess({ canvas }) {

	const [confettiPlaying, setConfettiPlaying] = useState(null);

	useEffect(() => {
		if (canvas.current && !confettiPlaying) {
			setConfettiPlaying(true);
			const stopConfetti = confetti(canvas.current);
			setTimeout(stopConfetti, 4000);
		}
	}, [canvas, confettiPlaying]);

	const {
		vendor
	} = useSelector(state => ({
		vendor: state.vendor
	}));

	useEffect(() => {
		if (vendor.id && vendor.name)
			trackEvent(EC_SHOP, E_ORDER_COMPLETED, `${vendor.id}_${vendor.name}`);
	}, [vendor.id, vendor.name]);

	const orderabl = <><b className="featureFont" style={{fontSize: "1.1rem"}}>ORDERABL<span className="brand-c">+</span></b></>;

	return <section className="text-left">
		<div className="inner checkout-success panel">
			<h2 style={{ fontSize: "3rem" }}>Thank you!</h2>
			<br />
			Thanks for ordering from <span>{vendor.name}</span> on {orderabl}.
			<br /><br />
			You should get an email soon with details of your order. If you want to head back to the shop, or go to your {orderabl} account, click the buttons below.
			<br /><br /><br/>
			<div className="flexy">
				<Link
					style={{ marginRight: 5 }}
					className="button"
					to="/me/orders"
				>Account</Link>
				<Link
					style={{ marginLeft: 5 }}
					className="button"
					to={vendorPath(vendor.slug)}
				>Shop</Link>
			</div>
		</div>
	</section>
}